import inboxTable from "../inboxDetails/inboxTable";
import searchAutoFill from "../searchAutoFill/searchAutoFill.vue";
// import lineChart from "@/pages/chart/lineChart.vue";
import emailDashboard from "../emailDashboard/emailDashboard";
import moment from "moment";
import { mapState, mapActions } from "vuex";

export default {
  components: { inboxTable, searchAutoFill,  emailDashboard  },
  computed: {
    ...mapState({
      selectedDomain: state => state.selectedDomain
    })
  },
  data() {
    return {
      reportData: {},
      selectedPeriod: "last-90",
      gmailInboxData: [],
      reportStats: {
        total_emails: { label: "Total Emails", key: "total_emails" },
        total_inbox: { label: "Inbox ", key: "total_inbox" },
        total_spam: { label: "Spam ", key: "total_spam" },
        total_promotions: { label: "Gmail Promotions", key: "total_promotions" },
        total_updates: { label: "Gmail Updates", key: "total_updates"},
        total_primary: { label: "Gmail Primary", key: "total_primary" },
      },
      fromDate: "",
      toDate: ""
    };
  },
  methods: {
    ...mapActions(["updateSelectedDomain"]),
    getDisplayTime(date) {
      return date ? moment(date).format('DD-MMM-YYYY') : "N/A";
    },
    updateDates({ fromDate, toDate }) {
      this.fromDate = fromDate;
      this.toDate = toDate;
    },
    handleReportUpdate(data) {
      this.reportData = data;
    },
    updateGmailData(data) {
      this.gmailInboxData = data;
    },
    getPercentage(part, total) {
      return total ? Math.min((part / total) * 100, 100).toFixed(1) : 0;
    },
    updateDomain(newDomain) {
      this.updateSelectedDomain(newDomain);
      this.$refs.inboxTableRef.addLoader();
    }
  },
};